import React from "react";
import { Hero } from "../components/sections/Hero";
import { ServiceCards } from "../components/sections/ServiceCards";
import { WhatWeSolve } from "../components/sections/WhatWeSolve";
import { Solutions } from "../components/sections/Solutions";
import { Process } from "../components/sections/Process";
import { WhyJorviko } from "../components/sections/WhyJorviko";
import { Technology } from "../components/sections/Technology";
import { BusinessStages } from "../components/sections/BusinessStages";
import { SocialImpact } from "../components/sections/SocialImpact";
import { ContactCTA } from "../components/sections/ContactCTA";
import { Marquee } from "../components/Marquee";

const MARQUEE_ITEMS = ["Azure", "AI Agents", "Automation", ".NET", "React", "RAG", "Power BI", "Cloud Native"];

export default function Home() {
  return (
    <>
      <Hero />
      <ServiceCards />
      <WhatWeSolve />
      <Marquee items={MARQUEE_ITEMS} className="border-y border-white/5" />
      <Solutions limit={2} />
      <Process />
      <WhyJorviko />
      <Technology />
      <BusinessStages />
      <SocialImpact />
      <ContactCTA />
    </>
  );
}
